export default {
  meta: {
    title: '备选址管理',
    url: '/storemanage/alternative', // 埋点用，记录所属模块
    // eventId: '44bd4317-d52e-465b-b66d-7592a4cf0359'
  },
};
